import React from "react";
import "./Button.css";

export default function Button({ text, className, href, newTab, onClick }) {
  const handleClick = async (event) => {
    if (onClick) {
      event.preventDefault();
      await onClick(event);

      if (href) {
        if (newTab) {
          window.open(href, "_blank");
        } else {
          window.location.href = href;
        }
      }
    }
  };

  return (
    <div className={className}>
      <a
        className="main-button"
        href={href}
        target={newTab && "_blank"}
        onClick={handleClick}
      >
        {text}
      </a>
    </div>
  );
}
